<template>
	<v-dialog
		v-model="show"
		@keydown.esc="hideDialog()"
		v-on="show ? { 'click:outside' : hideDialog } : ''"
		persistent
		scrollable
		width="450px"
	>
		<v-card>
			<v-card-title>
				Osoby, które zareagowały
				<v-btn icon @click="hideDialog" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
			<v-tabs
				v-model="tabIndex"
				ref="tabs"
			>
				<v-tab>Wszystkie</v-tab>
				<v-tab
					v-for="(reaction, i) in reactions"
					:key="'reaction-dialog-item-' + i"
					:color="reaction.color"
					v-show="reaction.display"
				>
					<v-icon
						:class="[ reaction.color + '--text']"
					>
						{{ reaction.iconLarge }}
					</v-icon>
				</v-tab>
			</v-tabs>
			<template v-if="dataResponse">
				<div v-for="(item, i) in dataResponse.data" :key="'mentions-dialog-item-' + i">
					<v-divider v-if="i > 0"></v-divider>
						<div class="pl-2 d-flex my-3 mt-4">
							<content-hover :user="item.user" avatar user-name hover-class="d-flex flex-row align-items-center font-14 bold" />
						</div>
				</div>
				<div v-if="loading" class="text-center text-muted py-4">
					<v-progress-circular
						indeterminate
						size="34"
						color="$light-muted"
					></v-progress-circular>
				</div>
			</template>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import ContentHover from "@/components/items/ContentHover";
export default {
	name: "PostUsersReactionsDialog",
	components: {
		ContentHover
	},
	props: {
		reactions: {
			type: Array,
			required: true
		},
		post: {
			type: Object,
			default: null
		},
		comment: {
			type: Object,
			default: null
		},
		message: {
			type: Object,
			default: null
		}
	},
	data () {
		return {
			loading: false,
			show: false,
			tabIndex: 0,
			dataResponse: null,
		}
	},
	watch: {
		tabIndex: function (i) {
			this.getData(i)
		}
	},
	created() {
		this.getData()
	},
	methods: {
		...mapActions('wall', [
			'getReactions'
		]),
		showDialog () {
			this.show = true
		},
		hideDialog () {
			this.show = false
			this.tabIndex = 0
		},
		async getData(i = null) {
			this.loading = true
			let type = (i) ? this.reactions[i - 1].type : null;

			let reactionable_type = null;
			let reactionable_id = null;
			if(this.post) {
				reactionable_type = 'post';
				reactionable_id = this.post.id;
			}
			else if(this.comment) {
				reactionable_type = 'comment';
				reactionable_id = this.comment.id;
			}
			else if(this.message) {
				reactionable_type = 'chatMessage'
				reactionable_id = this.message.id
			}

			this.dataResponse = []
			this.dataResponse = await this.getReactions({ type, reactionable_type, reactionable_id })
			this.loading = false
		}
	}
}
</script>

<style scoped>

</style>
